import React from "react";
import { View } from "react-native";

import CommentForm from "./CommentForm.js";
import Comment from "./Comment.js";

import { backendUrl } from "../../constants/Environment.js";
import { MonoText } from "../StyledText.js";

class CommentBox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showComments: true,
      showReplyTo: [],
      comments: [],
    };
    this._displayReplyForm = this._displayReplyForm.bind(this);
    this._addComment = this._addComment.bind(this);
    this._displayComment = this._displayComment.bind(this);
  }

  _displayReplyForm(parentId) {
    this.setState(
      { showReplyTo: this.state.showReplyTo.concat([parentId]) },
      () => {
        /**
         * Optionally add functionality here
         */
      }
    );
  }

  _displayComment(isFirst, bb) {
    return (
      <div style={isFirst ? {} : { marginLeft: 50 }}>
        <Comment
          author={bb.user && bb.user.name ? bb.user.name : "Unknown user"}
          body={bb.comment_text}
          key={bb.id}
          id={bb.id}
          parentId={bb.parent_comment_id}
          colors={this.props.colors}
          replyCallback={this._displayReplyForm}
          userId={this.props.userId}
        />
        {this.state.showReplyTo.includes(bb.id) && (
          <CommentForm
            colors={this.props.colors}
            parentId={bb.id}
            addComment={this._addComment}
          />
        )}
        {this.props.comments
          .filter((bb2) => bb2.parent_comment_id === bb.id)
          .map((bb3) => this._displayComment(false, bb3))}
      </div>
    );
  }

  // Get Comments
  _getComments() {
    return this.props.comments
      .filter((bc) => bc.parent_comment_id < 0 || !bc.parent_comment_id)
      .map((comment) => this._displayComment(true, comment));
  }

  _getCommentTitle(commentCount) {
    if (commentCount === 0) {
      return "No comments yet";
    }
    return ``;
  }

  render() {
    if (!this.props.allowComments) {
      return (
        <div>
          <MonoText>Comments turned off for this article.</MonoText>
        </div>
      );
    }
    const comments = this._getComments();
    let commentNodes = "";
    let buttonText = "Show comments";

    if (this.state.showComments) {
      buttonText = "Hide comments";
    }
    if (this.state.showComments) {
      commentNodes = <div className="comment-list">{comments}</div>;
    }
    return (
      <View style={{ margin: 18, marginBottom: 24 }}>
        <div className="comment-box container">
          <MonoText
            style={{
              marginTop: 18,
              color: this.props.colors.text,
              fontWeight: "bold",
              fontSize: 18,
            }}
          >
            Comments &nbsp;
          </MonoText>
          {this.props.userId > -1 && (
            <CommentForm
              colors={this.props.colors}
              addComment={this._addComment}
            />
          )}
          <h1>
            <small className="text-muted">
              <MonoText
                style={{
                  marginTop: 18,
                  color: this.props.colors.text,
                  fontSize: 14,
                }}
              >
                {this._getCommentTitle(comments.length)}
              </MonoText>
            </small>
          </h1>
          <hr />
          {comments.length > 0 && (
            <button onClick={this._handleClick.bind(this)}>{buttonText}</button>
          )}
          {commentNodes}
        </div>
      </View>
    );
  }

  _addComment(body, parentId) {
    const comment = {
      id: this.props.comments.length + 1,
      body,
      parentId,
    };
    if (this.props.userId < 0) {
      return;
    }
    if (!body || body.length < 1) {
      return;
    }
    /*
     * Define the post url first
     */
    fetch(`${backendUrl}/comments/add/`, {
      method: "POST",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Accept: "application/json",
        Authorization: "Bearer " + this.props.authToken,
      },
      body: JSON.stringify({
        author_id: this.props.userId,
        article_id: this.props.articleId,
        body: comment.body,
        parent_comment_id: comment.parentId,
      }),
    })
      .then((response) => {
        response.json().then((response) => {
          response.user = { name: this.props.username };
          this.props.appendComment(response);
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  _handleClick() {
    this.setState({
      showComments: !this.state.showComments,
    });
  }
}

export default CommentBox;
